// src/lib/spinSheet.js
// Talks to the Google Apps Script web app that backs the /spin page's
// Google Sheet (see google-apps-script/spin-sheet-logger.gs for the script
// to deploy and the URL to paste below).
//
// The sheet is the source of truth for "one spin per email": the page
// checks it before showing the wheel, and the log call is rejected as a
// duplicate if the email slipped in anyway (e.g. two tabs at once).

const SHEET_WEB_APP_URL = 'https://script.google.com/macros/s/AKfycbytD0LWoSbkRrpJXhcb4KfeECe-0euBIvSPmgQozTgKu4BQ_PBaADDLUGh_n7Y59I0O/exec';

function isConfigured() {
    if (!SHEET_WEB_APP_URL || SHEET_WEB_APP_URL.startsWith('PASTE_')) {
        console.warn('[spin] SHEET_WEB_APP_URL is not configured — skipping sheet calls.');
        return false;
    }
    return true;
}

// Resolves true if this email already has a row in the sheet. Throws on
// network/script errors so the caller can decide how to handle them.
export async function checkEmailEntered(email) {
    if (!isConfigured()) return false;

    const url = `${SHEET_WEB_APP_URL}?email=${encodeURIComponent(email.trim().toLowerCase())}`;
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Sheet check failed (${res.status})`);
    const data = await res.json();
    if (!data.ok) throw new Error(data.error || 'Sheet check failed');
    return Boolean(data.exists);
}

// Logs a spin. Resolves { duplicate: true } if the email was already in
// the sheet (no row added). Throws on network/script errors.
export async function logSpinEntry({ email, prize, code }) {
    if (!isConfigured()) return { duplicate: false };

    // text/plain avoids a CORS preflight (Apps Script web apps don't handle
    // OPTIONS requests); the Apps Script side still parses the body as JSON.
    const res = await fetch(SHEET_WEB_APP_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify({ email, prize, code }),
    });
    if (!res.ok) throw new Error(`Sheet log failed (${res.status})`);
    const data = await res.json();
    if (!data.ok) throw new Error(data.error || 'Sheet log failed');
    return { duplicate: Boolean(data.duplicate) };
}
